// 默认路由(简繁体)

// 通用
function routeTemplate(language){
	var languagePath = language?'/'+language:'',
		languageName = language?language:'';
	
	var routes = [
		  // PC
		  {
			path: '/' + languageName,
			name: languageName + 'home',
			meta: {
				title: languageName === 'HK'?'健康大數據魔鏡':'健康大数据魔镜'
			},
			component: () => import('../views'+ languagePath +'/home/index')
		  },
		  {
			path: languagePath + '/shop',
			name: languageName + 'shop',
			meta: {
				title: languageName === 'HK'?'米因健康商城':'米因健康商城'
			},
			component: () => import('../views'+ languagePath +'/shop/index')
		  },
		  
		  // 移动
		  {// 重定向到/m/home(用于在rem计算中辨识为移动端,如以/m辨识,可能存在PC中出现如/mark路由出错)
		  		path: languagePath + '/m',
		  		name: languageName + 'm',
				redirect: languagePath + '/m/home',
		  		meta: {
		  			title: languageName === 'HK'?'健康大數據魔鏡':'健康大数据魔镜'
		  		}
		  },
		  {
		  		path: languagePath + '/m/home',
		  		name: languageName + 'mHome',
		  		meta: {
		  			title: languageName === 'HK'?'健康大數據魔鏡':'健康大数据魔镜'
		  		},
		  		component: () => import('../views'+ languagePath +'/m/home/index')
		  },
		  {
		  		path: languagePath + '/m/shop',
		  		name: languageName + 'mShop',
		  		meta: {
		  			title: languageName === 'HK'?'米因健康商城':'米因健康商城'
		  		},
		  		component: () => import('../views'+ languagePath +'/m/shop/index')
		  },
		  {
		  		path: languagePath + '/m/codeErr',
		  		name: languageName + 'mCodeErr',
		  		meta: {
		  			title: languageName === 'HK'?'二維碼已失效':'二维码已失效'
		  		},
		  		component: () => import('../views'+ languagePath +'/m/codeErr/index')
		  }
		  
	]
	
	return routes;
}

// 独有路由(简繁体)
var only = [
	// 简体
	{
		path: '/placeDir',
		name: 'placeDir',
		meta: {
			title: '本地通'
		},
		component: () => import('../views/placeDir/index')
	},
	{
		path: '/m/placeDir',
		name: 'mPlaceDir',
		meta: {
			title: '本地通'
		},
		component: () => import('../views/m/placeDir/index')
	},
	{
		path: '/shop/detail',
		name: 'shopDetail',
		meta: {
			title: '产品详情'
		},
		component: () => import('../views/shop/detail')
	}
];

var base = [];

export default base.concat(routeTemplate(), routeTemplate('HK'), only);